import React from 'react'
import PropTypes from 'prop-types'
import InputField from './InputField'
import { FEMALE, MALE } from 'js/genders'
import { FormattedMessage } from 'react-intl'
import messages from './messages'

const GenderPicker = ({ gender, selectGender, error }) => (
  <div className="relative">
    <div className="mb-16 flex justify-between md:mb-24">
      {['female', 'male'].map((value, index) => {
        const selected =
          (gender === FEMALE && value === 'female') ||
          (gender === MALE && value === 'male')

        return (
          <InputField
            type="radio"
            selected={selected}
            name="gender"
            id={`gender-${value}`}
            index={index}
            key={index}
            onChange={(e) => {
              if (e.target.checked) selectGender(value)
            }}
            dataUid={`${value}_gender_button`}
            valueText={<FormattedMessage {...messages[value]} />}
          />
        )
      })}
    </div>
    {error && (
      <div
        className="c-signup-flow__error-bubble z-20"
        data-uid="error_message"
      >
        <div className="c-error-bubble">{error.errorMessage}</div>
      </div>
    )}
  </div>
)

GenderPicker.propTypes = {
  gender: PropTypes.string,
  selectGender: PropTypes.func.isRequired,
  error: PropTypes.any,
}

export default GenderPicker
